import cloneDeep from 'lodash/cloneDeep';
import templateHtml from './form-save-bar.html';

const component = {};

component.template = templateHtml;

component.bindings = {
    model: '<',
    isDisabled: '<?',
    saveCallback: '&',
    cancelCallback: '&',    
    changesSaved: '<'
};
component.controllerAs = 'vm';

function FormSaveBarController(
    $scope,
    Notify,
    $q,
    BdLocalize
) {
    const vm = this;
    vm.numOfChanges = 0;
    vm.initialState = null;
    vm.modalVisible = false;
    
    function setInitialState() {
        vm.initialState = cloneDeep(vm.model);        
    }

    vm.$onInit = function onInit() {        
        setInitialState();
    };

    function setNumOfChangesText() {
        vm.numOfChangesText = vm.numOfChanges === 1 
            ? BdLocalize.getString('Global.Component.SettingsSaveBar.Text.SettingsChangedSingular', '1 setting has been changed') 
            : BdLocalize.getString('Global.Component.SettingsSaveBar.Text.SettingsChangedPlural', `${vm.numOfChanges} settings have been changed`, [vm.numOfChanges]);
    }

    $scope.$watch('vm.model', () => {        
        if (vm.initialState && vm.model) {
            vm.numOfChanges = 0;
            Object.keys(vm.initialState).forEach(key => {
                if (Array.isArray(vm.initialState[key])) {
                    const settings = vm.initialState[key];
                    settings.forEach((setting, index) => {
                        Object.keys(setting).forEach(innerKey => {
                            if (setting[innerKey] !== vm.model[key][index][innerKey]) {
                                vm.numOfChanges += 1;
                            }
                        });
                    });
                } else if (vm.initialState[key] !== vm.model[key]) {
                    vm.numOfChanges += 1;
                }
            });            
                        
            if (vm.numOfChanges) {
                setNumOfChangesText();                
            } 
        }
    }, true);

    vm.saveClicked = function saveClicked() {
        if (vm.saveCallback) {
            return vm.saveCallback().then(() => {
                vm.initialState = cloneDeep(vm.model);
                vm.numOfChanges = 0;

                const successToast = BdLocalize.getString('Global.Component.SettingsSaveBar.Toast.SettingsSaved', 'Settings updated successfully');
                Notify.success(successToast);                
            });
        }

        return $q.when(true);
    };

    vm.cancelClicked = function cancelClicked() {
        if (vm.cancelCallback) {
            vm.cancelCallback({initialState: vm.initialState});
        }
        
        vm.numOfChanges = 0;
    };

    vm.isEnabled = function isEnabled() {
        if (typeof (vm.isDisabled) === 'undefined') {
            return true;
        } else {
            return !vm.isDisabled;
        }
    };

    vm.onModalOpen = function onModalOpen() {
        vm.modalVisible = true;
    };

    vm.onModalClose = function onModalClose() {
        vm.modalVisible = false;
    };
    
    vm.$onChanges = function onChanges(changes) {        
        if (changes.changesSaved) {
            // Reset the changes count.
            if (changes.changesSaved.previousValue === false && changes.changesSaved.currentValue === true) {
                vm.numOfChanges = 0;                

                // Changes have been saved, so we must set the initial state to the new one.                
                setInitialState();
            }
        }
    };
}

FormSaveBarController.$inject = [
    '$scope',
    'Notify',
    '$q',
    'BdLocalize'
];
component.controller = FormSaveBarController;
export const FormSaveBarComponent = component;
